import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Label } from '../../../../components/CiscoUi';

export function TopologiesActiveTemplateLabel(): ReactElement {
  const { t } = useTranslation();

  return (
    <Label colour="warning-alt" size="small">
      {t('topologies.activeTemplate')}
    </Label>
  );
}
